<div class="c-container">
  <div class="relative">
    <div
      #hueRing
      class="hue-ring"
      (mousedown)="startDrag($event, 'hue')"
      (touchstart)="startDrag($event, 'hue')"
      style="overflow: visible; position: relative"
    >
      <div
        class="hue-marker"
        [style.transform]="'rotate(' + hue() + 'deg)'"
      ></div>
    </div>

    <div
      #satVal
      class="sat-val"
      (mousedown)="startDrag($event, 'sat')"
      (touchstart)="startDrag($event, 'sat')"
    >
      <div
        class="sat-marker"
        [style.left]="saturation() + '%'"
        [style.top]="100 - value() + '%'"
      ></div>
    </div>
  </div>

  <div class="presets">
    <button
      *ngFor="let color of presets()"
      class="preset-color"
      [class.selected]="color === selectedPreset()"
      [style.background]="color"
      [style.color]="getLuminanceForHex(color) > 0.5 ? 'black' : 'white'"
      (click)="updateFromHex(color, true)"
    ></button>
  </div>

  <div class="controls">
    <div class="input-group">
      <select [ngModel]="format()" (ngModelChange)="setFormat($event)">
        <option value="hex">Hex</option>
        <option value="rgb">RGB</option>
      </select>

      <div class="inputs">
        <ng-container *ngIf="format() === 'hex'; else rgbInputs">
          <input
            type="text"
            [value]="currentColor()"
            (input)="updateFromHex($any($event.target).value)"
          />
        </ng-container>

        <ng-template #rgbInputs>
          <input
            type="number"
            [ngModel]="rgbValues().r"
            (ngModelChange)="updateRgb('r', $event)"
            min="0"
            max="255"
          />
          <input
            type="number"
            [ngModel]="rgbValues().g"
            (ngModelChange)="updateRgb('g', $event)"
            min="0"
            max="255"
          />
          <input
            type="number"
            [ngModel]="rgbValues().b"
            (ngModelChange)="updateRgb('b', $event)"
            min="0"
            max="255"
          />
        </ng-template>
      </div>
    </div>

    <div class="actions">
      <button class="cancel-btn" (click)="closePopup.emit()">Cancel</button>
      <button class="select-btn" (click)="colorSelected.emit(currentColor())">
        Select
      </button>
    </div>
  </div>
</div>
